import React, { useEffect, useRef, useState } from 'react';

/* Adds `is-in` to its own element the first time it scrolls into view, then
   stops observing. Styling lives in CSS; this only supplies the trigger. */
const Reveal = ({ className = '', threshold = 0.2, children }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShown(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return (
    <div className={`${className} ${shown ? 'is-in' : ''}`} ref={ref}>
      {children}
    </div>
  );
};

export default Reveal;
